<template>
	<button
		:class="[
			'link-button',
			alignment === 'center' ? 'link-button--centered' : ''
		]"
		type="button"
		:disabled="disabled"
	>
		<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'plus'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
		<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-if="icon === 'cross'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: 'LinkButton',
	components: {},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		alignment: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="scss">
.link-button {
	background: none;
	border: none;
	padding: 0;
	color: #04befb;
	text-decoration: underline;
	cursor: pointer;
	padding-left: 20px;
	position: relative;
	margin-top: 10px;

	&--centered {
		left: 50%;
		transform: translateX(-50%);
	}

	&:disabled,
	&[disabled] {
		color: #808080;
		cursor: unset;
	}

	svg {
		width: 14px;
		height: 14px;
		color: #04befb;
		fill: #04befb;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}
}
</style>
